export const kNormalCurveClass = "normal-curve"
export const kNormalCurveType = "Normal Curve"
export const kNormalCurvePrefix = "ADRN"
export const kNormalCurveLabelKey = "DG.Inspector.graphPlottedNormal"
export const kGaussianFitLabelKey = "DG.Inspector.graphPlottedGaussianFit"
export const kNormalCurveUndoAddKey = "DG.Undo.graph.showPlottedNormal"
export const kNormalCurveRedoAddKey = "DG.Redo.graph.showPlottedNormal"
export const kNormalCurveUndoRemoveKey = "DG.Undo.graph.hidePlottedNormal"
export const kNormalCurveRedoRemoveKey = "DG.Redo.graph.hidePlottedNormal"
export const kNormalCurveValueTitleKey = "" // We don't have a single value title because we display mean and sd
export const kNormalCurveMeanValueTitleKey = "DG.PlottedAverageAdornment.meanValueTitle"
export const kNormalCurveStdDevValueTitleKey = "DG.PlottedAverageAdornment.stDevValueTitle"
